/* FD colour carousel: swatch radios crossfade a double-buffered image pair and
   re-point the primary CTA at the tapped colour's variant. Only the tapped
   colour's image is ever fetched -- the back buffer loads on demand, decode()s,
   then fades in over the front. Reduced motion gets an instant swap (the CSS
   kills the transition). A stale decode (the shopper tapped again mid-load) is
   dropped by the token guard rather than painted out of order. */
(() => {
  document.querySelectorAll('[data-fd-ccar]').forEach((section) => {
    let front = section.querySelector('.fd-ccar__img--front');
    let back = section.querySelector('.fd-ccar__img--back');
    const nameEl = section.querySelector('[data-fd-ccar-name]');
    const fabricEl = section.querySelector('[data-fd-ccar-fabric]');
    const cta = section.querySelector('[data-fd-ccar-cta]');
    const ctaName = section.querySelector('[data-fd-ccar-cta-name]');
    const mediaLink = section.querySelector('[data-fd-ccar-media-link]');
    if (!front || !back || !cta) return;

    let token = 0;

    section.addEventListener('change', async (event) => {
      const radio = event.target.closest('input[type="radio"][data-variant-id]');
      if (!radio) return;

      /* Fabric travels with the colour: a multi-fabric product (Bishop) would
         otherwise keep the lead variant's fabric word under a different fabric's
         sofa. Missing data-fabric leaves the word alone (fail-open). */
      if (fabricEl && radio.dataset.fabric) fabricEl.textContent = radio.dataset.fabric;
      if (nameEl) nameEl.textContent = radio.dataset.name;
      if (ctaName) ctaName.textContent = radio.dataset.name;
      cta.href = `${cta.dataset.productUrl}?variant=${radio.dataset.variantId}`;

      const mine = ++token;
      back.srcset = radio.dataset.srcset;
      back.sizes = front.sizes || '';
      back.src = radio.dataset.img;
      back.alt = radio.dataset.alt;

      /* Wait for the bytes, not for decode(): decode()'s promise can sit
         unresolved forever on an image that is stacked at opacity 0 (seen on
         Chromium against this very section), so it only gets a 300ms head
         start to pre-rasterise before the fade runs regardless. */
      if (!back.complete || back.naturalWidth === 0) {
        const outcome = await new Promise((resolve) => {
          back.addEventListener('load', () => resolve('load'), { once: true });
          back.addEventListener('error', () => resolve('error'), { once: true });
        });
        if (outcome === 'error') return;
      }
      try {
        await Promise.race([
          back.decode(),
          new Promise((resolve) => setTimeout(resolve, 300)),
        ]);
      } catch (e) {
        /* a rejected decode still paints via the normal path */
      }
      if (mine !== token) return;

      /* The photo link (merchant checkbox) follows the PHOTO, not the tap: it is
         re-pointed only here, as the new image is shown, so a slow or failed
         load never leaves the link opening a colour the photo isn't showing. */
      if (mediaLink) mediaLink.href = `${cta.dataset.productUrl}?variant=${radio.dataset.variantId}`;

      back.style.opacity = '1';
      back.removeAttribute('aria-hidden');
      front.style.opacity = '0';
      front.setAttribute('aria-hidden', 'true');
      const swap = front;
      front = back;
      back = swap;
      front.classList.replace('fd-ccar__img--back', 'fd-ccar__img--front');
      back.classList.replace('fd-ccar__img--front', 'fd-ccar__img--back');
    });
  });
})();

/* Landing-cue dismiss. The :target cue ends on its own 2.4s timer, but a
   shopper who has clearly moved on shouldn't have to wait it out -- the FIRST
   tap or key after landing marks the band .fd-ccar--seen and the CSS kills the
   cue instantly. Deliberately NOT bound to scroll/pointermove: reading the band
   and scrolling through it is not "moving on", so the cue survives that and
   ends on the timer. The hero link's own click fires BEFORE the hashchange that
   arms us, so a tap can never dismiss the landing it just caused. Fail-open:
   no JS (or a throw here) leaves the timer as the only dismissal, which is the
   pre-existing behaviour. */
(() => {
  const SEEN = 'fd-ccar--seen';
  let disarm = null;

  function arm() {
    if (disarm) {
      disarm();
      disarm = null;
    }
    const id = location.hash.slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target || !target.classList.contains('fd-ccar')) return;

    /* A fresh landing re-shows the cue, including on a band dismissed earlier. */
    document.querySelectorAll('.' + SEEN).forEach((el) => el.classList.remove(SEEN));

    let done = false;
    const end = () => {
      if (done) return;
      done = true;
      target.classList.add(SEEN);
      document.removeEventListener('click', end, true);
      document.removeEventListener('keydown', end, true);
    };
    document.addEventListener('click', end, { capture: true, once: true });
    document.addEventListener('keydown', end, { capture: true, once: true });
    disarm = () => {
      done = true;
      document.removeEventListener('click', end, true);
      document.removeEventListener('keydown', end, true);
    };
  }

  window.addEventListener('hashchange', arm);
  arm();
})();
